import React from 'react';

import { PageButton } from './page-button.component';
import { Pages } from './pages.component';

type PageControlsProps = {
  pageIndex: number;
  pageSize: number;
  totalCount?: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onPageChange: (value: number) => void;
};

export const PageControls = ({
  pageIndex,
  pageSize,
  totalCount,
  canPreviousPage,
  canNextPage,
  onPreviousPage,
  onNextPage,
  onPageChange,
}: PageControlsProps): JSX.Element => (
  <div className="space-x-2 flex items-center">
    <PageButton
      label="Previous page"
      disabled={!canPreviousPage}
      onClick={onPreviousPage}
    >
      Prev
    </PageButton>

    <Pages
      pageIndex={pageIndex}
      pageSize={pageSize}
      totalCount={totalCount}
      onPageClick={onPageChange}
    />

    <PageButton label="Next page" disabled={!canNextPage} onClick={onNextPage}>
      Next
    </PageButton>
  </div>
);
